import { render, staticRenderFns } from "./DeleteMicrolearningVideoDialog.vue?vue&type=template&id=6651205a"
import script from "./DeleteMicrolearningVideoDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMicrolearningVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports